import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const Input = z.object({
  level: z.enum(["error", "warn", "info"]).default("error"),
  source: z.string().min(1).max(100),
  message: z.string().min(1).max(4000),
  stack: z.string().max(8000).optional(),
  route: z.string().max(300).optional(),
  context: z.record(z.string(), z.any()).optional(),
});

// Naive per-user in-memory rate limit (best effort; per worker instance).
const buckets = new Map<string, { count: number; reset: number }>();
function rateLimit(userId: string, limit = 30, windowMs = 60_000) {
  const now = Date.now();
  const b = buckets.get(userId);
  if (!b || b.reset < now) {
    buckets.set(userId, { count: 1, reset: now + windowMs });
    return true;
  }
  if (b.count >= limit) return false;
  b.count++;
  return true;
}

export const recordError = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) => Input.parse(d))
  .handler(async ({ data, context }) => {
    if (!rateLimit(context.userId)) return { ok: false as const, error: "rate_limited" };
    try {
      const { recordErrorDirect } = await import("@/server/errors.server");
      await recordErrorDirect(data);
      return { ok: true as const };
    } catch (e) {
      console.error("recordError failed", e);
      return { ok: false as const, error: "log_failed" };
    }
  });
